import { render, staticRenderFns } from "./advancedApprovalSettings.vue?vue&type=template&id=321f6313&scoped=true"
import script from "./advancedApprovalSettings.vue?vue&type=script&lang=js"
export * from "./advancedApprovalSettings.vue?vue&type=script&lang=js"
import style0 from "./advancedApprovalSettings.vue?vue&type=style&index=0&id=321f6313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f6313",
  null
  
)

export default component.exports